module.exports = __webpack_public_path__ + "static/ingresar-aace81ae025578ebfce230504ea91db0.jpg";